import { render } from "./DialogCouponVersionWarning.vue?vue&type=template&id=8aa832b8&scoped=true"
import script from "./DialogCouponVersionWarning.vue?vue&type=script&lang=js"
export * from "./DialogCouponVersionWarning.vue?vue&type=script&lang=js"

import "./DialogCouponVersionWarning.vue?vue&type=style&index=0&id=8aa832b8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-8aa832b8"

export default script